import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography, CardMedia, Card, CardTitle
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import ListsHeader from '../ListsHeader';
import { nullStatePropTypes } from './nullStatePropTypes';
import CreateNewList from '../CreateNewList';

const CompactNullView = ({
  cardBody,
  cardTitle,
  imageAlt,
  imageUrl,
  clickID,
}) => {

  return (
    <Card
      data-component="Lists"
      data-testid="lists"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
    >
      <ListsHeader actions={['learnMore']} clickID={clickID} />
      <div
        className={
          classNames(
            '@3xl:sui-pr-8',
            '@7xl:sui-max-w-md',
            'sui-flex-col',
            'sui-flex',
            'sui-gap-4',
            'sui-h-full',
            'sui-overflow-hidden',
          )
        }
      >
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
        <div
          className={
            classNames(
              '@3xl:sui-pr-8',
              '@7xl:sui-max-w-md',
              'sui-flex-col',
              'sui-flex',
              'sui-gap-4',
              'sui-h-full',
              'sui-pt-4'
            )
          }
        >
          <CardTitle
            header={(
              <Typography
                variant="h2"
                weight="display"
              >
                {cardTitle}
              </Typography>
            )}
          />
          {cardBody}
          <CreateNewList variant="button" />
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = {
  clickID: PropTypes.string.isRequired,
  ...nullStatePropTypes
};

export default CompactNullView;
